// Public API: notify/success/info/warning/error/neutral + dismiss/clear + configure

import type { ReactNode } from "react";
import { emitToast } from "./bus";
import type {
  NotifyOptions,
  ToastId,
  ToastPosition,
  ToasterDefaults,
} from "./types";

let seq = 0;
const nextId = () => ++seq;

let defaults: ToasterDefaults = {
  position: "top-right",
  duration: 3500,
  dismissible: true,
  showProgress: true,
  pauseOnHover: true,
  maxPerStack: 0,
};

export function configureToasts(partial: Partial<ToasterDefaults>) {
  defaults = { ...defaults, ...partial };
}

export function getToastDefaults(): ToasterDefaults {
  return defaults;
}

export function notify(opts: NotifyOptions = {}): ToastId {
  const id = opts.id ?? nextId();
  const content: ReactNode | undefined = opts.content ?? opts.text;
  emitToast({ type: "ADD", payload: { id, content, opts } });
  return id;
}

export function dismiss(id: ToastId) {
  emitToast({ type: "DISMISS", payload: { id } });
}

export function clear() {
  emitToast({ type: "CLEAR" });
}

// Variant helpers
export const toast = {
  notify,
  dismiss,
  clear,
  success: (o?: NotifyOptions) => notify({ variant: "success", ...o }),
  info:    (o?: NotifyOptions) => notify({ variant: "info",    ...o }),
  warning: (o?: NotifyOptions) => notify({ variant: "warning", ...o }),
  error:   (o?: NotifyOptions) => notify({ variant: "error",   ...o }),
  neutral: (o?: NotifyOptions) => notify({ variant: "neutral", ...o }),
};
